export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const HOST_ENV = process.env.REACT_APP_HOST_ENV || '';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
